import React from 'react';
import { Box, Container } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { colors } from '../../theme/tokens';

type SectionProps = {
  children: React.ReactNode;
  tone?: 'base' | 'alt';
  id?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | false;
  compact?: boolean;
  sx?: SxProps<Theme>;
  component?: React.ElementType;
};

const Section: React.FC<SectionProps> = ({
  children,
  tone = 'base',
  id,
  maxWidth = 'lg',
  compact = false,
  sx,
  component = 'section',
}) => (
  <Box
    component={component}
    id={id}
    sx={{
      backgroundColor: tone === 'alt' ? colors.bgAlt : colors.bg,
      py: compact ? { xs: 6, md: 8 } : { xs: 8, md: 12 },
      scrollMarginTop: 96,
      ...sx,
    }}
  >
    <Container maxWidth={maxWidth}>{children}</Container>
  </Box>
);

export default Section;
